import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthResult } from 'src/app/models/auth-result.model';
import { Plano } from 'src/app/models/plano.model';
import { Proposta } from 'src/app/models/proposta.model';
import { SDKErrorResponse } from 'src/app/models/sdk-error-response.model';
import { SDKResponse } from 'src/app/models/sdk-response.model';
import { Simulacao } from 'src/app/models/simulacao.model';
import { CreditoService } from 'src/app/services/credito.service';

import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-invoice-options',
  templateUrl: './invoice-options.component.html',
  styleUrls: ['./invoice-options.component.scss']
})
export class InvoiceOptionsComponent implements OnInit {

  simulacao: Simulacao;
  simulando: boolean;
  planoSelecionado: Plano;
  authResult: AuthResult;

  constructor(
    private router: Router,
    private appState: AppStateService,
    private credito: CreditoService,
    private location: Location,) { }

  ngOnInit() {
    this.doSimulacao();
    this.getAuthResult();
  }

  async next() {
    this.appState.setLoading(true).then(() => {
      setTimeout(() => {
        this.router.navigate(['simulation']);
        this.appState.setLoading(false);
      }, 3000);
    });
  }

  async doSimulacao() {
    await this.appState.setLoading(true).then((success) => {
      this.credito.simulacao().then(simulacao => {
        this.simulacao = simulacao;
      }).catch(e => {
        this.router.navigate(['error']);
      }).finally(() => {
        this.appState.setLoading(false);
      });
    });
  }

  changeRadioPlano(plano: Plano) {
    let indexPlanoSelecionado = this.simulacao.planos.findIndex(p => p.plano === plano.plano);
    this.simulacao.planos.map(p => delete p['selecionado']);
    this.simulacao.planos[indexPlanoSelecionado]['selecionado'] = true;
    this.appState.setSimulacao(this.simulacao);
    this.planoSelecionado = plano;
  }

  getAuthResult() {
    this.appState.getAuthResult.pipe(take(1)).subscribe(authResult => {
      this.authResult = authResult;
    })
  }

  back() {
    this.location.back();
  }

}
